import { createSelector } from 'reselect';
import { flatten, flow, map } from 'lodash/fp';

import positionsSelector from './positionsSelector';

const lineUpSelector = createSelector(positionsSelector, flow(map('selections'), flatten));

export default lineUpSelector;
